import React, { useEffect, useState, useCallback } from "react";
import Layout from "../../Layout";
import TaskList from "../../Components/CRC/TaskList";
import TicketForm from "../../Components/CRC/CreateTicketForm";
import withTranslationWrapper from "../../HOC/withTranslation";
import instance from "../../axios";
import ConfirmDialoag from "../../Components/common/ConfirmDialoag";
import { useDispatch } from "react-redux";
import { notifySuccess } from "../../Utils/CustomNotifcations";
import TicketHeader from "../../Components/CRC/TicketHeader";
import Loader from "../../Layout/Loader";
import TaskView from "../../Components/CRC/TaskView";
import { toast } from "react-toastify";

const CRC = (props) => {
  const dispatch = useDispatch();
  const [filters, setFilters] = useState({
    currentStatus: "",
    searchText: "",
    from: "",
    to: ""
  });

  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 10,
    total: 0,
    hasNext: false
  });

  const [data, setData] = useState([]);
  const [taskCounts, setTaskCounts] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  const [viewTask, setViewTask] = useState(null);
  const [isShowCreateForm, setIsShowCreateForm] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [ticketComments, setTicketComments] = useState([]);


  const buildParams = (page) => ({
    page,
    limit: pagination.pageSize,
    ...(filters.currentStatus && { currentStatus: filters.currentStatus }),
    ...(filters.searchText && { search: filters.searchText }),
    ...(filters.from && { from: filters.from }),
    ...(filters.to && { to: filters.to })
  });


  const getData = useCallback(async (type) => {
    try {
      setIsLoading(true);

      let page = pagination.currentPage;

      if (type === "next") page += 1;
      if (type === "prev") page -= 1;
      if (type === "first") page = 1;
      if (type === "last") page = Math.ceil(pagination.total / pagination.pageSize);

      const res = await instance.get("/api/tickets/get", {
        params: buildParams(page)
      });

      setData(res.data || []);

      setPagination({
        currentPage: res.page,
        pageSize: res.pageSize,
        total: res.total,
        hasNext: res.hasNext
      });

    } catch (error) {
      if (error?.statusCode === "440") props.history.push("/logout");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, [filters, pagination.currentPage, pagination.pageSize, pagination.total]);


  const getTaskCounts = async () => {
    try {
      const response = await instance.get("/api/tickets/analytic");

      const taskCountsArray = Object.keys(response).map((key) => ({
        status: key,
        count: response[key]?.count || 0
      }));

      setTaskCounts(taskCountsArray);

    } catch (error) {
      if (error?.statusCode === "440") props.history.push("/logout");
      console.error(error);
    }
  };


  useEffect(() => {
    getTaskCounts();
  }, []);

  useEffect(() => {
    getData();
  }, [filters]);


  const handleAddCloseForm = () => {
    setSelectedTask(null);
    setIsShowCreateForm((prev) => !prev);

    if (isShowCreateForm) {
      getData();
      getTaskCounts();
    }
  };



  const handleView = (item) => {
    setViewTask(item);
    getTicketComments(item)
    getTicketActivity(item)
  }
  const handleCloseView = () => setViewTask(null);

  const handleEdit = (item) => {
    setSelectedTask(item);
    setIsShowCreateForm(true);
    setViewTask(null)
  };


  const deleteTickets = async () => {
    try {
      await instance.delete(`/api/tickets/${selectedTask.id}`);

      dispatch(notifySuccess("ticketDeleted"));

      getData();
      getTaskCounts();

    } catch (err) {
      console.error(err);
    } finally {
      handleCloseDelete();
    }
  };

  const handleOpenDelete = (item) => {
    setSelectedTask(item);
    setIsDelete(true);
  };

  const handleCloseDelete = () => {
    setIsDelete(false);
    setSelectedTask(null);
  };


  const onSearch = (value) => {
    setFilters({
      currentStatus: value?.status || "",
      searchText: value?.searchText || "",
      from: value?.dateRange?.from || "",
      to: value?.dateRange?.to || ""
    });

    setPagination((prev) => ({
      ...prev,
      currentPage: 1
    }));
  };


  const ticketAssignToUser = async (userId) => {
    console.log("userId", userId)
    return
    try {
      await instance.put(`/api/tickets/assign/${viewTask.id}`);
      dispatch(notifySuccess("ticketAssignSuccessfully"));
    } catch (err) {
      console.error(err);
    } finally {
      // handleCloseDelete();
    }
  };


  // ticket against comments
  const getTicketComments = async (ticket) => {
    try {
      const response = await instance.get(`/api/ticketcomments/get?ticketId=${ticket.id}`);
      setTicketComments(response);

    } catch (error) {
      if (error?.statusCode === "440") props.history.push("/logout");
      console.error(error);
    }
  };

  const createTicketComment = async (payload) => {
    try {
      const response = await instance.post(`/api/ticketcomments`, payload);
      dispatch(notifySuccess("commentAdded"));
      getTicketComments(viewTask)

    } catch (error) {
      if (error?.statusCode === "440") props.history.push("/logout");
      toast.error(error?.message||"Failed to create ticket comments")
    }
  };

  const updateTicketComment = async (payload) => {
    try {
      const response = await instance.put(`/api/ticketcomments/${payload.id}`, payload);
      dispatch(notifySuccess("commentUpdated"));
      getTicketComments(viewTask)

    } catch (error) {
      if (error?.statusCode === "440") props.history.push("/logout");
      console.error(error);
    }
  };

  const deleteTicketComment = async (deletedId) => {
    try {
      const response = await instance.delete(`/api/ticketcomments/${deletedId}`);
      dispatch(notifySuccess("commentDeleted"));
      getTicketComments(viewTask)

    } catch (error) {
      if (error?.statusCode === "440") props.history.push("/logout");
      console.error(error);
    }
  };

  const [ticketActivity, setTickeActivity] = useState([])

  const getTicketActivity = async (ticket) => {
    try {
      const response = await instance.get(`/api/ticketlogs/get?ticketId=${ticket.id}`);
      setTickeActivity(response?.data || []);

    } catch (error) {
      if (error?.statusCode === "440") props.history.push("/logout");
      console.error(error);
    }
  };
  return (
    <Layout {...props} taskCounts={taskCounts} isLoadData={isLoading}>
      <div className="main-content-page" style={{ marginTop: "5rem" }}>

        {!viewTask && (
          <TicketHeader
            translate={props.translate}
            isShowCreateForm={isShowCreateForm}
            handleAddCloseForm={handleAddCloseForm}
            onSearch={onSearch}
          />
        )}

        {isShowCreateForm ? (
          <TicketForm
            {...props}
            handleAddCloseForm={handleAddCloseForm}
            selectedTask={selectedTask}
            getTaskCounts={getTaskCounts}
          />
        ) : viewTask ? (
          <TaskView
            task={viewTask}
            onClose={handleCloseView}
            handleEdit={handleEdit}
            ticketAssignToUser={ticketAssignToUser}
            translate={props.translate}
            ticketComments={ticketComments}
            createTicketComment={createTicketComment}
            updateTicketComment={updateTicketComment}
            deleteTicketComment={deleteTicketComment}
            ticketActivity={ticketActivity}
          />
        ) : (
          <>
            {isLoading ? (
              <Loader />
            ) : (
              <TaskList
                translate={props.translate}
                tasks={data}
                handleEdit={handleEdit}
                handleView={handleView}
                handleDelete={handleOpenDelete}
                pagination={pagination}
                onPageChange={getData}
              />
            )}
          </>
        )}

        {isDelete && (
          <ConfirmDialoag
            onCancel={handleCloseDelete}
            onOk={deleteTickets}
            title={props.translate("areYouWantToDelete")}
          >
            {selectedTask?.name}
          </ConfirmDialoag>
        )}

      </div>
    </Layout>
  );
};

export default withTranslationWrapper(CRC);